import type { ADFEntity } from '@atlaskit/adf-utils/types';
import type { Schema } from '@atlaskit/editor-prosemirror/model';

/**
 * Recursively checks whether a single ADF node (and all its descendants) are
 * compatible with the given ProseMirror schema.
 *
 * A node is considered compatible when:
 *  - Its `type` exists in `schema.nodes`
 *  - Every mark on it exists in `schema.marks`
 *  - All child content nodes are themselves compatible (recursive)
 */
export const isAdfNodeCompatibleWithSchema = (node: ADFEntity, schema: Schema): boolean => {
	// Check node type exists in schema
	if (!schema.nodes[node.type]) {
		return false;
	}

	// Check all marks are supported
	if (node.marks) {
		for (const mark of node.marks) {
			if (mark && !schema.marks[mark.type]) {
				return false;
			}
		}
	}

	// Recursively check children
	if (node.content) {
		for (const child of node.content) {
			if (child && !isAdfNodeCompatibleWithSchema(child, schema)) {
				return false;
			}
		}
	}

	return true;
};
